<template>
    <div>
        <h2 class="md:text-xl font-black mb-3">{{ $page.props.productVariant?.title || product.title }}</h2>
    </div>
</template>

<script>
import {Link} from "@inertiajs/vue3";

export default {
    components: {Link},
    props: {
        product: Object
    }
}
</script>
